import ModalManager from '@airbus/mms/js/services/ModalManager'
import CollectionManager from '@/js/services/CollectionManager'

/**
 * @param {Container} di
 * @param {App} app
 */
export default (di, app) => {
    di.set('app', () => app)

    di.set('modalManager', () => {
        return new ModalManager()
    })

    di.set('collectionManager', () => {
        return new CollectionManager(di)
    })
}
